import { render, staticRenderFns } from "./RatingBar.vue?vue&type=template&id=49230da8&scoped=true&"
import script from "./RatingBar.vue?vue&type=script&lang=js&"
export * from "./RatingBar.vue?vue&type=script&lang=js&"
import style0 from "./RatingBar.vue?vue&type=style&index=0&id=49230da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49230da8",
  null
  
)

export default component.exports